import { type MouseEventHandler, ReactNode } from 'react';
import { HistoryBackButton } from 'components';
import { Typography } from '@mui/material';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles(() => ({
  header: {
    paddingTop: 5,

    '@media (max-width: 1199px)': {
      padding: '0 10px',
    },
  },
  title: {
    marginTop: 30,
  },
}), { name: 'MainPageHeader' });

export type MainPageHeaderProps = {
  title: ReactNode;
  handleHistoryBack?: MouseEventHandler<HTMLButtonElement>;
};

const MainPageHeader = ({ title, handleHistoryBack } : MainPageHeaderProps) : JSX.Element => {
  const classes = useStyles();
  
  return (
    <div className={classes.header}>
      <HistoryBackButton onClick={handleHistoryBack} />

      <Typography className={classes.title} color="textPrimary" variant="h2">
        {title}
      </Typography>
    </div>
  );
};

export default MainPageHeader;
